module.exports = __webpack_public_path__ + "static/img/12.845113d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/10/zh/12.png
// module id = QIG8
// module chunks = 0